var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFavoriteFilledIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 12,
    viewBox: "0 0 13 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.46234 3.439L1.47999 3.59935L1.36203 3.61171C0.481197 3.75057 0.148249 4.88264 0.86902 5.4632L3.19201 7.325L2.42072 10.1993L2.39687 10.3098C2.25381 11.1853 3.23887 11.8525 4.02007 11.3512L6.5318 9.741L9.04125 11.3512L9.13986 11.4078C9.93572 11.8135 10.88 11.0906 10.6406 10.1994L9.87361 7.33L12.1926 5.4632L12.2806 5.38447C12.9107 4.75888 12.5091 3.64894 11.5816 3.59935L8.59622 3.441L7.51924 0.672456C7.17058 -0.224152 5.891 -0.224152 5.54234 0.672456L4.46234 3.439Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFavoriteFilledIcon);
export default __webpack_public_path__ + "static/media/favorite-filled-icon.403ebeffdf311a3008a2d6870ada8f25.svg";
export { ForwardRef as ReactComponent };